import React, { useState } from "react";
import { IconType } from "react-icons";
import { Link } from "react-router-dom";
import { Menu, MenuItem, IconButton } from "@mui/material";
import { MdMoreVert } from "react-icons/md";
import "./CommonCard.scss";
import { CustomTypeCommonCard } from "../../../../helper/constants";

interface IMenuOptions {
  menuItems: Array<string>;
  menuActions: Array<(event) => void>;
}

export interface ICommonCardContent {
  type?: CustomTypeCommonCard; // will customize the card based on type
  icon?: IconType; // will show icon on left side of the card
  title: string; // will show on top
  extraTitle?: string; // will show under title in smaller font
  description?: string; // will show under title
  extraDetails?: string; // will show under description in smaller font
  link?: string; // will make a linkeable title to navigate to specific location path
  action?: () => void; // will perform action on click of card
  menuOptions?: IMenuOptions; // will show a 3 dots menu icon on right side of title
  onClick?: () => void; // will trigger a function on click of the card
}
const CommonCard: React.FC<ICommonCardContent> = (props) => {
  const IconComponent = props?.icon || null;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // only for menu options icon
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={`commonCard ${props?.type}`} onClick={props?.action}>
      <div className={`${(props?.type?.toLowerCase() !== 'virtualclassrooms' && props?.type?.toLowerCase() !== 'engines') && "row"}`} >
        {/* ICON CONTENT */}
        <div className={`${(props?.type?.toLowerCase() == 'virtualclassrooms' || props?.type?.toLowerCase() == 'engines') ?  "iconContent":"col-2"}`} onClick={props.onClick}>
          {IconComponent && (
            <div className="iconContent">
              {<IconComponent className="icon large" />}
            </div>
          )}
        </div>
        {/* TITLE, DESCRIPTION , AND EXTRA DETAILS CONTENT */}
        <div className={`${(props?.type?.toLowerCase() == 'virtualclassrooms' || props?.type?.toLowerCase() == 'engines') ?  "textContent":"col-9"}`} onClick={props.onClick}>
          <div className="textContent">
            <div>
              {props.link ? (
                <Link 
                onClick={props?.action} to={props.link} 
                className={`${(props?.type?.toLowerCase() == 'virtualclassrooms' || props?.type?.toLowerCase() == 'engines') ?  "title cardCommonTitle":"title"}`}
                >
                  {props.title}
                </Link>
              ) : (
                <div 
                className={`${(props?.type?.toLowerCase() == 'virtualclassrooms' || props?.type?.toLowerCase() == 'engines') ?  "title cardCommonTitle":"title"}`}
                onClick={props?.action}>{props.title}</div>
              )}
              {props?.extraTitle && (
                <div className="extraTitle">{props.extraTitle}</div>
              )}
              {props?.description && (
                <div className="description">{props.description}</div>
              )}
              {props?.extraDetails && (
                <div className="extraDetails">{props.extraDetails}</div>
              )}
            </div>
          </div>
        </div>
        <div className={`${(props?.type?.toLowerCase() == 'virtualclassrooms' || props?.type?.toLowerCase() == 'engines') ?  "optionsContent":"col-1"}`}>
          {/* DOTS MENU OPTIONS CONTENT */}
          {props?.menuOptions && (
            <div className="optionsContent">
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <MdMoreVert />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                {props?.menuOptions?.menuItems?.map((menuItem, index) => (
                  <MenuItem
                    key={index}
                    className="commonCardMenuItem"
                    onClick={(event) => {
                    props?.menuOptions?.menuActions[index](event);
                      handleClose();
                    }}
                  >
                    {menuItem}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommonCard;
